import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import ValidationInfo from './ValidationInfo'
import ValidationText from './ValidationText'
import FormGroup from './FormGroup'
import { isNotEmpty } from '../utils'

class TextInput extends Component {

  static propTypes = {
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    formatter: PropTypes.func,
    group: PropTypes.object,
    helpText: PropTypes.string,
    info: PropTypes.string,
    isValid: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({
        errors: PropTypes.object,
        valid: PropTypes.bool
      })
    ]),
    label: PropTypes.string,
    name: PropTypes.string,
    note: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    size: PropTypes.number,
    step: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    withEnabler: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = this.createState(props)
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value !== this.state.value) {
      this.setState(this.createState(newProps))
    }
  }

  createState(props) {
    return {
      value: props.value,
      enablerChecked: props.withEnabler
        ? isNotEmpty(props.value)
        : true
    }
  }

  @autobind
  handleEnablerChange(e) {

    e.stopPropagation()

    const { target: { checked } } = e
    const value = !checked
      ? ''
      : this.state.value

    this.handleChange({
      target: {
        value,
        checked
      }
    })

  }

  @autobind
  handleInternalChange({ target: { value } }) {
    this.setState({ value })
  }

  @autobind
  handleChange(e) {

    if (e && e.stopPropagation) {
      e.stopPropagation()
    }

    const { target, target: { checked } } = e
    let { value } = target

    if (
      this.props.type === 'number'
      && this.props.formatter
      // only validate if the enabler is checked
      && (this.props.withEnabler ? checked : true)
    ) {
      value = this.props.formatter(value)
    }

    const newState = {
      value
    }

    if (this.props.withEnabler) {
      newState.enablerChecked = checked || isNotEmpty(value)
    }

    this.setState(newState, () => {
      if (this.props.onChange) {
        this.props.onChange({
          target: {
            name: this.props.name,
            value
          }
        })
      }
    })

  }

  render() {

    let { onChange } = this.props
    const {
      className = '',
      group,
      helpText,
      info,
      note,
      isValid,
      label,
      name,
      required,
      size = 8,
      type = 'text',
      placeholder,
      disabled,
      readOnly,
      withEnabler,
      step,
      formatter

    } = this.props

    const autoComplete = this.props.autoComplete || undefined

    const { enablerChecked, value } = this.state
    let onBlur = null

    if (type === 'number' && formatter) {
      onBlur = this.handleChange
      onChange = this.handleInternalChange
    }

    const input = (
      <input
        type={type}
        className="form-control"
        id={name}
        name={name}
        value={value}
        required={required}
        placeholder={placeholder}
        disabled={disabled || (withEnabler && !enablerChecked)}
        readOnly={readOnly}
        ref={(ref) => {
          this.inputRef = ref
          return ref
        }}
        step={step}
        lang="de"
        onBlur={onBlur}
        autoComplete={autoComplete}
      />
    )

    const enabler = withEnabler
      ? (
        <span className="input-group-addon">
          <label
            htmlFor={`${name}Enabler`}
            className="helper"
          >
            <input
              type="checkbox"
              className="form-control"
              id={`${name}Enabler`}
              name={`${name}Enabler`}
              checked={disabled ? false : enablerChecked}
              disabled={disabled}
              onChange={this.handleEnablerChange}
              lang="de"
            />
            <span />
          </label>
        </span>
      )
      : null

    return (
      <FormGroup
        label={label}
        name={name}
        info={info}
        note={note}
        onChange={onChange}
      >
        <div className={`col-xs-${size} ${className}`}>
          {group || withEnabler
            ? (
              <div className="input-group">
                {enabler}
                {input}
                <span className="input-group-addon">{group.after}</span>
              </div>
            )
            : input}

          {
            helpText
              ? <div className="help-block">{helpText}</div>
              : null
          }

          <ValidationText isValid={isValid}>
            <ValidationInfo isValid={isValid} />
          </ValidationText>
        </div>
      </FormGroup>
    )

  }
}

export { TextInput as default }



// WEBPACK FOOTER //
// ./src/shared/components/TextInput.js